export const featureFlags = {
  dataLoad: true,
  template: true,
  language: true,
  debugFeatures: window._env_.REACT_APP_DEBUG_FEATURES_ENABLED === 'true',
  distribution: window._env_.REACT_APP_FEATURE_DISTRIBUTION_ENABLED === 'true',
}
